import { z } from "zod";

export const alertFormSchema = z.object({
    searchQuery: z.string().min(1, "Search query is required"),
    alertName: z.string().min(1, "Alert name is required"),
    property: z.string().min(1, "Property is required"),
    valueInr: z.string().refine((val) => !isNaN(Number(val)) && Number(val) > 0, {
      message: "Value must be a positive number",
    }),
    lastTradedPrice: z.string().refine((val) => !isNaN(Number(val)), {
      message: "Last traded price must be a number",
    }),
    note: z.string().optional(),
    volume: z.number().optional(),
    ltp: z.number().optional(),
    averageTradePrice: z.number().optional(),
  }).superRefine((data, ctx) => {
    if (!data.property || !data.valueInr) return;
  
    const valueInr = Number(data.valueInr);

    if (data.property === 'VOLUME') {
      if (data.volume !== undefined && data.volume !== null && valueInr <= data.volume) {
        ctx.addIssue({
          path: ["valueInr"],
          code: z.ZodIssueCode.custom,
          message: `Volume must be greater than ${data.volume}`,
        });
      }
    } else if (data.property === 'AVGPRICE') {
      if (data.averageTradePrice !== undefined && data.averageTradePrice !== null && valueInr === data.averageTradePrice) {
        ctx.addIssue({
          path: ["valueInr"],
          code: z.ZodIssueCode.custom,
          message: `Value must be different from average trade price ${data.averageTradePrice}`,
        });
      }
    } else {
      if (data.ltp !== undefined && data.ltp !== null && valueInr === data.ltp) {
        ctx.addIssue({
          path: ["valueInr"],
          code: z.ZodIssueCode.custom,
          message: `Value must be different from current price ${data.ltp}`,
        });
      }
    }
  });
